import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

console.log('<<------- process.env ------->>',  process.env && process.env.NODE_ENV, process.env)
export default new Router({
    // mode: 'history',
    mode: process.env.NODE_ENV === "development" ? '' : 'history',
    base: `/ll/`,
    routes: [
        { path: '/',name: 'goMini', component: () => import('@/pages/goMini/index.vue')},
        {
            path: '/webview/:id',
            name: 'index',
            component: () => import('@/pages/webview/index'),
            meta: { title: 'H5页面' }
        },
        {
            path: '/goMini/index',
            name: 'goMini',
            component: () => import('@/pages/goMini/index'),
            meta: { title: '点击联系我' }
        },
        {
            path: '/columnDetail',
            name: 'columnDetail',
            component: () => import('@/pages/goMini/columnDetail'),
            meta: { title: '点击观看线上课程' }
        },
    ]
})